module.exports = __webpack_public_path__ + "static/img/ico_marking.4beb8e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/ico_marking.svg
// module id = AmF2
// module chunks = 0